(function () {
  var EVENT_PREFIX = 'ichizen:';
  var STORAGE_PREFIX = 'ichizen:analytics:sent:';
  var SUBMITTED_FORM_KEY = 'ichizen:analytics:submitted-form';
  var MAX_VALUE_LENGTH = 160;
  var MAX_QUEUE_ATTEMPTS = 20;
  // GTM's data layer keeps keys from earlier pushes, so each event clears the
  // parameters it does not set. Keep in sync with gtm/GTM-5W3LH2P7_ichizen-events.json.
  var DATA_LAYER_PARAMS = [
    'event_location',
    'source',
    'content_type',
    'content_id',
    'event_label',
    'link_url',
    'article_handle',
    'article_title',
    'product_handle',
    'product_state',
    'cta_type',
    'form_type',
    'search_term',
    'search_term_length',
    'page_path',
  ];
  var queue = [];
  var flushTimer = null;

  function normalizeEventName(eventName) {
    if (!eventName) return '';
    return eventName.indexOf(EVENT_PREFIX) === 0 ? eventName : EVENT_PREFIX + eventName;
  }

  function canPublish() {
    return (
      window.Shopify &&
      window.Shopify.analytics &&
      typeof window.Shopify.analytics.publish === 'function'
    );
  }

  function safeString(value, maxLength) {
    if (value === undefined || value === null) return '';
    return String(value).replace(/\s+/g, ' ').trim().slice(0, maxLength || MAX_VALUE_LENGTH);
  }

  function safeUrl(value) {
    if (!value) return '';

    try {
      var url = new URL(value, window.location.origin);
      var sameOrigin = url.origin === window.location.origin;
      return sameOrigin ? url.pathname + url.hash : url.origin + url.pathname;
    } catch (error) {
      return safeString(value);
    }
  }

  function safeSearchTerm(value) {
    var term = safeString(value, 100);

    if (!term) return '';
    if (/[\w.+-]+@[\w.-]+\.[a-zA-Z]{2,}/.test(term)) return '[redacted]';
    if (term.replace(/\D/g, '').length >= 8) return '[redacted]';

    return term;
  }

  function sanitizePayload(payload) {
    var source = payload || {};
    var sanitized = {};

    Object.keys(source).forEach(function (key) {
      if (/email|phone|tel|name|address|body|message|customer/i.test(key)) return;

      var value = source[key];
      if (value === undefined || value === null || value === '') return;

      if (key === 'link_url' || key === 'page_path') {
        sanitized[key] = safeUrl(value);
      } else if (key === 'search_term') {
        sanitized[key] = safeSearchTerm(value);
      } else if (typeof value === 'number' || typeof value === 'boolean') {
        sanitized[key] = value;
      } else {
        sanitized[key] = safeString(value);
      }
    });

    sanitized.page_path = sanitized.page_path || window.location.pathname;
    sanitized.page_title = sanitized.page_title || safeString(document.title);

    return sanitized;
  }

  function scheduleFlush() {
    if (flushTimer || queue.length === 0) return;

    flushTimer = window.setTimeout(function () {
      flushTimer = null;
      flushQueue();
    }, 250);
  }

  function flushQueue() {
    if (!canPublish()) {
      queue = queue.filter(function (entry) {
        entry.attempts += 1;
        return entry.attempts < MAX_QUEUE_ATTEMPTS;
      });
      scheduleFlush();
      return;
    }

    queue.splice(0).forEach(function (entry) {
      publish(entry.eventName, entry.payload);
    });
  }

  function publish(eventName, payload) {
    if (!canPublish()) {
      queue.push({ eventName: eventName, payload: payload, attempts: 0 });
      scheduleFlush();
      return false;
    }

    try {
      window.Shopify.analytics.publish(eventName, payload);
      return true;
    } catch (error) {
      return false;
    }
  }

  function pushToDataLayer(eventName, payload) {
    var dataLayerEvent = eventName.indexOf(EVENT_PREFIX) === 0
      ? eventName.slice(EVENT_PREFIX.length)
      : eventName;
    var dataLayerPayload = { event: dataLayerEvent, ichizen_event_name: dataLayerEvent };

    DATA_LAYER_PARAMS.forEach(function (key) {
      dataLayerPayload[key] = undefined;
    });
    Object.keys(payload || {}).forEach(function (key) {
      dataLayerPayload[key] = payload[key];
    });

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(dataLayerPayload);
  }

  function getOnceKey(eventName, payload, customKey) {
    if (customKey) {
      return [STORAGE_PREFIX, customKey, window.location.pathname].join('|');
    }

    return [
      STORAGE_PREFIX,
      eventName,
      payload.event_location || payload.source || '',
      window.location.pathname,
    ].join('|');
  }

  function hasSent(key) {
    try {
      return window.sessionStorage.getItem(key) === '1';
    } catch (error) {
      return false;
    }
  }

  function markSent(key) {
    try {
      window.sessionStorage.setItem(key, '1');
    } catch (error) {
      // Ignore storage failures; tracking should not affect the page.
    }
  }

  function track(eventName, payload, options) {
    var normalizedEventName = normalizeEventName(eventName);
    var sanitizedPayload = sanitizePayload(payload);
    var onceKey;

    if (!normalizedEventName) return false;

    if (options && options.once) {
      onceKey = getOnceKey(normalizedEventName, sanitizedPayload, options.onceKey);
      if (hasSent(onceKey)) return false;
      markSent(onceKey);
    }

    pushToDataLayer(normalizedEventName, sanitizedPayload);
    return publish(normalizedEventName, sanitizedPayload);
  }

  function payloadFromElement(element) {
    var dataset = element.dataset || {};
    var text = dataset.ichizenAnalyticsLabel || element.textContent || '';
    var payload = {
      event_location: dataset.ichizenAnalyticsLocation,
      source: dataset.ichizenAnalyticsSource,
      content_type: dataset.ichizenAnalyticsContentType,
      content_id: dataset.ichizenAnalyticsContentId,
      event_label: text,
    };

    if (element.href) {
      payload.link_url = element.href;
    } else if (dataset.ichizenAnalyticsUrl) {
      payload.link_url = dataset.ichizenAnalyticsUrl;
    }

    return payload;
  }

  function rememberSubmittedForm(form) {
    if (!form.id) return;

    try {
      window.sessionStorage.setItem(SUBMITTED_FORM_KEY, form.id);
    } catch (error) {
      // Ignore storage failures; tracking should not affect the page.
    }
  }

  // Shopify marks every form of the same type as posted, so a footer newsletter
  // also shows success after a waitlist signup. Only the submitted form counts.
  function isSubmittedForm(form) {
    var submittedFormId;

    if (!form || !form.id) return true;

    try {
      submittedFormId = window.sessionStorage.getItem(SUBMITTED_FORM_KEY);
    } catch (error) {
      return true;
    }

    if (submittedFormId !== form.id) return false;

    try {
      window.sessionStorage.removeItem(SUBMITTED_FORM_KEY);
    } catch (error) {
      // Ignore storage failures; tracking should not affect the page.
    }
    return true;
  }

  function trackPageMarkers() {
    document.querySelectorAll('[data-ichizen-analytics-once]').forEach(function (element) {
      var eventName = element.getAttribute('data-ichizen-analytics-once');
      var payload = payloadFromElement(element);
      var onceKey = element.getAttribute('data-ichizen-analytics-once-key');

      if (!isSubmittedForm(element.closest('form'))) return;

      track(eventName, payload, { once: true, onceKey: onceKey });
    });
  }

  function eventLocation(element) {
    var explicitLocation = element.closest('[data-ichizen-analytics-location]');

    if (explicitLocation) {
      return explicitLocation.getAttribute('data-ichizen-analytics-location');
    }
    if (element.closest('cart-drawer')) return 'cart_drawer';
    if (element.closest('header')) return 'header';
    if (element.closest('footer, [data-footer-group]')) return 'footer';
    if (/^\/products\//.test(window.location.pathname)) return 'product_page';
    if (/^\/collections\//.test(window.location.pathname)) return 'collection_page';
    if (window.location.pathname === '/' || window.location.pathname === '/en') return 'home';

    return 'page_content';
  }

  function purchaseCta(element) {
    var clickable = element.closest('a[href], button, input[type="submit"]');
    var context;
    var analyticsContext;
    var analyticsData;
    var url;
    var path;
    var ctaType = '';

    if (!clickable || clickable.disabled || clickable.getAttribute('aria-disabled') === 'true') return null;

    if (clickable.matches('[name="add"], .product-form__submit')) {
      ctaType = 'add_to_cart';
    } else if (
      clickable.matches('[name="checkout"], #checkout, #CartDrawer-Checkout') ||
      clickable.closest('.cart__ctas')
    ) {
      ctaType = 'begin_checkout';
    } else if (clickable.closest('.shopify-payment-button')) {
      ctaType = 'buy_now';
    } else if (clickable.href) {
      try {
        url = new URL(clickable.href, window.location.origin);
        path = url.pathname.replace(/^\/en(?=\/)/, '');
      } catch (error) {
        return null;
      }

      if (/^\/products\/[^/]+/.test(path)) {
        ctaType = 'view_product';
      } else if (/^\/collections(?:\/|$)/.test(path)) {
        ctaType = 'view_collection';
      } else if (/^\/cart(?:\/|$)/.test(path)) {
        ctaType = 'view_cart';
      }
    }

    if (!ctaType) return null;

    context = clickable.closest('[data-ichizen-product-id]');
    analyticsContext = clickable.closest('[data-ichizen-analytics-location]');
    analyticsData = analyticsContext ? analyticsContext.dataset : {};
    ctaType = analyticsData.ichizenAnalyticsCtaType || ctaType;

    return {
      element: clickable,
      payload: {
        event_location: eventLocation(clickable),
        content_type: analyticsData.ichizenAnalyticsContentType || 'purchase_cta',
        content_id:
          analyticsData.ichizenAnalyticsArticleHandle ||
          (context ? context.getAttribute('data-ichizen-product-id') : (path || '')),
        article_handle: analyticsData.ichizenAnalyticsArticleHandle,
        article_title: analyticsData.ichizenAnalyticsArticleTitle,
        product_handle: analyticsData.ichizenAnalyticsProductHandle,
        product_state: analyticsData.ichizenAnalyticsProductState,
        cta_type: ctaType,
        event_label:
          clickable.getAttribute('data-ichizen-analytics-label') ||
          clickable.getAttribute('aria-label') ||
          clickable.textContent ||
          '',
        link_url: clickable.href || '',
      },
    };
  }

  function onClick(event) {
    var trigger = event.target.closest('[data-ichizen-analytics-event]');
    var commerceTrigger = purchaseCta(event.target);

    if (trigger && trigger.getAttribute('aria-disabled') !== 'true') {
      track(trigger.getAttribute('data-ichizen-analytics-event'), payloadFromElement(trigger));
    }

    if (commerceTrigger) {
      track('purchase_cta_click', commerceTrigger.payload);
    }
  }

  function onSubmit(event) {
    var form = event.target;
    var trackedForm;
    var trackedFormData;
    var input;
    var searchTerm;

    if (!form.matches) return;

    rememberSubmittedForm(form);

    trackedForm = form.closest('[data-ichizen-analytics-form]');
    if (trackedForm) {
      trackedFormData = trackedForm.dataset || {};
      track(trackedFormData.ichizenAnalyticsForm, {
        event_location: trackedFormData.ichizenAnalyticsLocation || eventLocation(form),
        content_type: 'lead_form',
        content_id: form.id || trackedFormData.ichizenAnalyticsForm,
        form_type: trackedFormData.ichizenAnalyticsForm,
      });
    }

    if (!form.matches('form[role="search"]')) return;

    input = form.querySelector('[name="q"]');
    searchTerm = input ? safeSearchTerm(input.value) : '';
    if (!searchTerm) return;

    track('site_search_submit', {
      event_location: form.closest('header') ? 'header_search' : 'site_search',
      search_term: searchTerm,
      search_term_length: searchTerm === '[redacted]' ? undefined : searchTerm.length,
    });
  }

  document.addEventListener('click', onClick);
  document.addEventListener('submit', onSubmit, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', trackPageMarkers, { once: true });
  } else {
    trackPageMarkers();
  }

  window.IchizenAnalytics = {
    track: track,
    flush: flushQueue,
  };
})();
